exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".weekDays li{display:inline-block;cursor:pointer;margin-right:10px}.weekDays li input{margin-right:5px}.weekDays li:hover{color:#337fff}\n", "", {"version":3,"sources":["/Users/ionut/Work/Mycontracts/mycontracts-ui/src/components/Repeater/repeatViews/weekly/weeklyViews.scss"],"names":[],"mappings":"AAAA,aAEI,qBACA,eACA,iBAAkB,CAJtB,mBAMM,gBAAiB,CANvB,mBASM,aAAc,CAAA","file":"weeklyViews.scss","sourcesContent":[".weekDays {\n  li {\n    display: inline-block;\n    cursor: pointer;\n    margin-right: 10px;\n    input {\n      margin-right: 5px;\n    }\n    &:hover {\n      color: #337fff;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
